import {getClient} from "./axiosClient";

const client = getClient()


export async function getMsisdnsForCompanyId(id, page, search)
{
    return  await client.get(`v1/msisdn/company/${id}`, {params: { page: page, search: search }})
}

export async function updateMsisdnStatus(msisdn)
{
    return await client.put(`v1/msisdn/${msisdn.msisdn}/status`, {
        status: msisdn.status
    })
}

export async function updateMsisdnStatusAdmin(msisdn)
{
    return await client.put(`v1/msisdn/${msisdn.msisdn}/status`, {
        status: msisdn.status,
        lockStatus: msisdn.statusLocked
    })
}

export async function updateMsisdn(msisdn)
{
    return await client.put(`v1/msisdn/${msisdn.id}`, msisdn)
}

export async function getHoursForMsisdn(msisdn, startDate, endDate)
{
    let response = await client.get(`v1/hours/msisdn/${msisdn}`, { params: {
        startDate: startDate,
        endDate: endDate
    }})

    return response;
}

export async function getGeofenceTransactionsForMsisdns(msisdns, startDate, endDate, includeOverlaps)
{
    return await client.post(`v1/messages/msisdns`, msisdns, { params: {
        startDate: startDate,
        endDate: endDate,
        includeOverlaps: includeOverlaps
    }})
}

export async function registerMsisdn(msisdn, companyId)
{
    return await client.post('v1/msisdn/' + companyId, msisdn)
}

export async function deleteMsisdn(msisdn, companyId)
{
    return await client.delete(`v1/msisdn/${msisdn}/company/${companyId}`)
}

export async function getLocations(msisdn, from, to)
{
    const response = await client.get(`v1/location/${msisdn}`, { params: { from, to } });
    return response;
}

export async function requestLocationUpdate(msisdn)
{
    const response = await client.post(`v1/location/request/${msisdn}`);
    return response;
}

export async function getMsisdnOverview(companyId, page, search)
{
    return await client.get(`v1/msisdn/overview/company/${companyId}`, { params: { page: page, search: search }})
}

export async function sendMessage(msisdn, message)
{
    return await client.post(`v1/fcm/notification/${msisdn}`, message)
}

export async function sendFcmMessage(msisdn, message)
{
    return await client.post(`v1/fcm/${msisdn}`, message)
}

export async function sendWelcomeSms(msisdn)
{
    return await client.post(`v1/msisdn/${msisdn}/send-sms`)
}

//============= Physical Activities =============//

export async function getActivities(msisdn, params) {
    return await client.get(`/v1/activity/msisdn/${msisdn}`, { params });
}

// ============== Zone Planning ================ //
export async function getZonePlanning(msisdn, companyId) {
    return await client.get(`/v1/msisdn/${msisdn}/geofence-assignments/company/${companyId}`);
}

export async function updateZonePlanning(msisdn, companyId, planning) {
    return await client.put(`/v1/msisdn/${msisdn}/geofence-assignments/company/${companyId}`, planning);
}